
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certification/get-certified",
      function () {
        return require("private-next-pages/certification/get-certified.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certification/get-certified"])
      });
    }
  